import { render, staticRenderFns } from "./list-products.vue?vue&type=template&id=1e279169"
import script from "./list-products.vue?vue&type=script&lang=js"
export * from "./list-products.vue?vue&type=script&lang=js"
import style0 from "./list-products.vue?vue&type=style&index=0&id=1e279169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports